import React from 'react';
import { Grid, Tooltip, Typography } from '@mui/material';
import SparkCarousel from 'sharedComponents/UI/SparkCarousel';
import MemoryCard from '../MemoryCard';
import { useInfiniteMemoriesQuery } from 'hooks/memory';
import { useSparkSearchContext } from 'hooks/common/useSparkSearchContextV2';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { MemoryContentCardCategory } from 'types/Memory';

type MarketplaceSectionProps = { contentCard: MemoryContentCardCategory };

function MarketplaceSection({ contentCard }: MarketplaceSectionProps) {
  const {
    joinedMemories,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
  } = useInfiniteMemoriesQuery({
    url: contentCard.attributes.filter,
  });

  const handlePageUpdate = () => {
    if (!hasNextPage && isFetching) {
      return;
    }
    fetchNextPage();
  };

  if (!joinedMemories?.length && !isLoading) {
    return null;
  }
  return (
    <Grid container gap={-1} direction='column' marginBottom={3}>
      <Grid container item paddingLeft={2} alignItems='center' gap={1}>
        <Typography fontFamily='Mont-Semibold' variant='h6'>
          {contentCard.attributes.name}
        </Typography>
        <Tooltip title={contentCard.attributes.description || ''}>
          <InfoOutlinedIcon
            fontSize='small'
            sx={{ color: 'var(--color-label)' }}
          />
        </Tooltip>
      </Grid>
      <Grid item container>
        <SparkCarousel
          isLoading={isLoading}
          isFetchingNextPage={isFetchingNextPage}
          onLastElementView={handlePageUpdate}
        >
          {joinedMemories?.map((memory) => (
            <MemoryCard key={memory.id} joinedMemory={memory} />
          ))}
        </SparkCarousel>
      </Grid>
    </Grid>
  );
}

export default MarketplaceSection;
